/**
 * Subscription provider constants and helper functions.
 */

/**
 * Subscription provider types.
 */
export const SubscriptionProvider = {
  APPLE: "APPLE",
  STRIPE: "STRIPE",
} as const;

export type SubscriptionProviderType =
  (typeof SubscriptionProvider)[keyof typeof SubscriptionProvider];

/**
 * Checks if the provider is Apple.
 */
export function isAppleProvider(provider: string | null | undefined): boolean {
  return provider === SubscriptionProvider.APPLE;
}
